export class LadingCodeParams {
    page = 1;
    limit = 10;
    status?: number;
    search?: string;
    customerRowGuid?: string;
    ladingCode?: string;
    statusPrint?: number;
    fromDate?: number;
    toDate?: number;
}
